import React, { PropTypes } from 'react';
import { v4 } from 'node-uuid';
import classnames from 'classnames';

const Stats = ({ title, subtitle, stats, className, background }) => (
  <section className={classnames('block block-stats', className, background)}>
    <div className="row columns">
      <div className="block-header">
        <h2>{ title }</h2>
        { subtitle && <h3 className="as-h4-important">{ subtitle }</h3> }
      </div>
    </div>
    <div className="row align-center">
    { stats.map(stat => (
    <div key={v4()} className="small-16 medium-4 columns">
      <div className={classnames("stat-box", stat.statClass)}>
        <div className="stat-value-container">
          <div className="stat-value" dangerouslySetInnerHTML={{ __html: stat.stat }}/>
        </div>
        <div className="stat-label" dangerouslySetInnerHTML={{ __html: stat.label }} />
      </div>
    </div>)) }
    </div>
  </section>
);

Stats.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  stats: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    stat: PropTypes.string,
  })),
  background: PropTypes.string,
};

export default Stats;
